import ValueFactory from '../../util/ValueFactory';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { QueryActions } from '../actions/QueryActions';
import { QueryVariable } from '../../domain/enrichment/EnrichmentDomain';
import DeploymentModel from '../../domain/stream/model/DeploymentModel';
import { EnrichmentSchema } from '../../domain/enrichment/EnrichmentSchemaDomains';

export interface QueryState {
  queryVariable: QueryVariable;
  schema: DeploymentModel<EnrichmentSchema> | null;
  isUpdate: boolean;
  isDirty: boolean;
}

const initialState: QueryState = {
  queryVariable: ValueFactory.initializeQueryVariable(),
  schema: { stage: 'DRAFT' } as DeploymentModel<EnrichmentSchema>,
  isUpdate: false,
  isDirty: false,
};

export const queryReducer = (state = initialState, action: ReduxBaseAction<any, QueryActions>) => {
  switch (action.type) {
    case 'CHANGE_QUERY':
      return { ...state, queryVariable: action.payload || ValueFactory.initializeQueryVariable(), isDirty: true };
    case 'CHANGE_QUERY_VARIABLE_SCHEMA':
      return { ...state, schema: action.payload };
    case 'CHANGE_QUERY_IS_UPDATE':
      return { ...state, isUpdate: action.payload };
    case 'CLEAR_QUERY':
      return { ...state, queryVariable: ValueFactory.initializeQueryVariable(), isUpdate: false, schema: null, isDirty: false };
    case 'CHANGE_QUERY_DIRTY':
      return { ...state, isDirty: action.payload };
    default:
      return state;
  }
};
